import { Collapse } from "antd";
import styled from "styled-components";

const CollapseStyled = styled(Collapse)`
  background-color: transparent !important;
  border: none !important;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .ant-collapse-item {
    background-color: #fff;
    border-radius: 1em !important;
    overflow: hidden;
    border: 1px solid #d9d9d9;

    &:last-child {
      border-radius: 1em;
    }
  }

  .ant-collapse-header {
    text-transform: uppercase;
    background-color: #ededed;
  }

  .ant-collapse-content-box {
    padding: 1em 2em;
  }
`;

export default CollapseStyled;
